import React, { ReactNode } from 'react';
import { IntlProvider } from 'react-intl';

import { localeMap } from '@futrli/localisation/core';

interface ReportIntlProviderProps {
  children: ReactNode;
  locale: string;
}

export const ReportIntlProvider = ({ children, locale }: ReportIntlProviderProps) => (
  <IntlProvider locale={locale} messages={localeMap[locale]}>
    {children}
  </IntlProvider>
);
